import { HaloProvider } from '@prenuvo/halo-web';
import { QueryClientProvider } from '@tanstack/react-query';

import { UnauthenticatedHandler } from '@/core/auth';
import { queryClient } from '@/core/react-query';
import { SessionHandler } from '@/core/session';
import { UserProvider } from '@/core/user';

import { LOCALES } from './i18n';
import { Router } from './router';

export function App() {
  return (
    <HaloProvider language="en" locales={LOCALES}>
      <QueryClientProvider client={queryClient}>
        <UserProvider>
          <Router />
        </UserProvider>

        <UnauthenticatedHandler />
        <SessionHandler />
      </QueryClientProvider>
    </HaloProvider>
  );
}
